import { withStyles } from '@material-ui/core';
import MuiTextField from '@material-ui/core/TextField';

const styles = {
  root: {
    '& label.Mui-focused': {
      color: 'currentColor',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'inherit',
      },
    },
  },
};

const TwTextArea = withStyles(styles)(
  ({ value, onChange, onBlur, multiline, variant, margin, label, placeholder, rows, rowsMax }) => (
    <MuiTextField
      value={value || ''}
      onChange={onChange}
      onBlur={onBlur}
      label={label !== undefined ? label : 'Note...'}
      placeholder={placeholder}
      rows={rows || 3}
      rowsMax={rowsMax}
      className="w-full block"
      multiline={multiline !== undefined ? multiline : true}
      variant={variant || 'outlined'}
      margin={margin || 'normal'}
    />
  ),
);

export default TwTextArea;
